module.exports = __webpack_public_path__ + "img/product_4.5c49fb8.webp";